import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const ToggleStatusDialog = ({ open, onClose, onConfirm, status, name }) => {
  const action = status ? 'désactiver' : 'activer';
  
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningIcon color="warning" />
        Confirmation
      </DialogTitle>
      <DialogContent>
        <Typography>
          Êtes-vous sûr de vouloir {action} {name} ?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Annuler
        </Button>
        <Button
          onClick={onConfirm}
          color={status ? "error" : "success"}
          variant="contained"
        >
          {action}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ToggleStatusDialog;